import { DeleteIcon } from "assets";
import { Toggle } from "components";
import React from "react";
import { TableRowItem } from "../../components";
import { AdminTableBody } from "../../components/tbody";
import { TableDataItem } from "../../components/td";
import styles from "./styles.module.css";

// University Institutions Table Body Item
export interface InstitutionAgentsTableBodyItem {
  avatar: string;
  name: string;
  address: string;
  email: string;
  agency: string;
  id: string;
  status: boolean;
}

// University Institutions Table Body Props
interface TableBodyProps {
  tableBodyItems: InstitutionAgentsTableBodyItem[];
  tableBodyClassName: string;
  updateStatus: (id: string, stat: boolean) => void;
}

const InstitutionAgentsTableBody: React.FC<TableBodyProps> = ({
  tableBodyItems,
  tableBodyClassName,
  updateStatus,
}) => {
  return (
    <AdminTableBody customClassName={`${styles.tableContainer} `}>
      {tableBodyItems.map((item, idx) => (
        <TableRowItem key={`${item.name} ${idx}`} customClassName={styles.tableRow}>
          <TableDataItem className={`${styles.tableRowItem} ${tableBodyClassName} ${styles.uniName}`}>
            <img className={styles.logo} src={item.avatar} /> {item.name}
          </TableDataItem>
          <TableDataItem className={`${styles.tableRowItem} ${tableBodyClassName} ${styles.capitalize}`}>
            {item.agency}
          </TableDataItem>
          <TableDataItem className={`${styles.tableRowItem} ${tableBodyClassName} ${styles.capitalize}`}>
            {item.address}
          </TableDataItem>
          <TableDataItem className={`${styles.tableRowItem} ${tableBodyClassName}`}>
            <a target={"_blank"} rel="noreferrer" className={styles.website} href={item.email}>
              {item.email}
            </a>
          </TableDataItem>
          <TableDataItem className={`${styles.tableRowItem} ${tableBodyClassName}`}>
            <Toggle onClick={() => updateStatus(item.id, !item.status)} checked={item.status} />
          </TableDataItem>
        </TableRowItem>
      ))}
    </AdminTableBody>
  );
};

export { InstitutionAgentsTableBody };
